/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetUserDocumentFile400Response,
  GetUserDocumentFile422Response,
  GetUserDocumentItem200Response,
  GetUserDocumentItem400Response,
  GetUserDocumentItem404Response,
  GetUserDocumentList200Response,
  GetUserDocumentList400Response,
  GetUserDocumentList422Response,
  UserDocumentType,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetUserDocumentFile400ResponseFromJSON,
  GetUserDocumentFile400ResponseToJSON,
  GetUserDocumentFile422ResponseFromJSON,
  GetUserDocumentFile422ResponseToJSON,
  GetUserDocumentItem200ResponseFromJSON,
  GetUserDocumentItem200ResponseToJSON,
  GetUserDocumentItem400ResponseFromJSON,
  GetUserDocumentItem400ResponseToJSON,
  GetUserDocumentItem404ResponseFromJSON,
  GetUserDocumentItem404ResponseToJSON,
  GetUserDocumentList200ResponseFromJSON,
  GetUserDocumentList200ResponseToJSON,
  GetUserDocumentList400ResponseFromJSON,
  GetUserDocumentList400ResponseToJSON,
  GetUserDocumentList422ResponseFromJSON,
  GetUserDocumentList422ResponseToJSON,
  UserDocumentTypeFromJSON,
  UserDocumentTypeToJSON,
} from '../models/index'

export interface GetUserDocumentFileRequest {
  uuid: string
  type?: GetUserDocumentFileTypeEnum
}

export interface GetUserDocumentItemRequest {
  applicationId: string
}

export interface GetUserDocumentListRequest {
  page?: number
  perPage?: number
  search?: string
  types?: Array<UserDocumentType>
}

/**
 * UserDocumentsApi - interface
 *
 * @export
 * @interface UserDocumentsApiInterface
 */
export interface UserDocumentsApiInterface {
  /**
   * Отдаёт файл документа бинарным потоком, без конверта success_response: заголовки Content-Type (MIME-тип файла), Content-Disposition и Content-Length. uuid должен указывать на документ, а не на папку. Документ чужой бизнес-сущности не отличается от несуществующего — 404 (администратору доступен любой). Требуется подтверждённый email.
   * @summary Скачать файл документа
   * @param {string} uuid UUID документа
   * @param {'inline' | 'attachment'} [type] Тип Content-Disposition: inline — открытие в браузере, attachment — скачивание (по умолчанию inline)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserDocumentsApiInterface
   */
  getUserDocumentFileRaw(
    requestParameters: GetUserDocumentFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Отдаёт файл документа бинарным потоком, без конверта success_response: заголовки Content-Type (MIME-тип файла), Content-Disposition и Content-Length. uuid должен указывать на документ, а не на папку. Документ чужой бизнес-сущности не отличается от несуществующего — 404 (администратору доступен любой). Требуется подтверждённый email.
   * Скачать файл документа
   */
  getUserDocumentFile(
    requestParameters: GetUserDocumentFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Содержимое папки: данные папки и документы внутри неё с временными ссылками на файлы (список не пагинируется, сортировка по дате создания по возрастанию). Папка чужой бизнес-сущности не отличается от несуществующей — 404 (администратору доступна любая папка). Требуется подтверждённый email.
   * @summary Документы внутри папки
   * @param {string} applicationId UUID папки документов
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserDocumentsApiInterface
   */
  getUserDocumentItemRaw(
    requestParameters: GetUserDocumentItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserDocumentItem200Response>>

  /**
   * Содержимое папки: данные папки и документы внутри неё с временными ссылками на файлы (список не пагинируется, сортировка по дате создания по возрастанию). Папка чужой бизнес-сущности не отличается от несуществующей — 404 (администратору доступна любая папка). Требуется подтверждённый email.
   * Документы внутри папки
   */
  getUserDocumentItem(
    requestParameters: GetUserDocumentItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserDocumentItem200Response>

  /**
   * Постраничный список корневых папок документов текущего пользователя. Обычный пользователь видит только папки своих заявок и запросов на товарный знак, администратор — все. Поиск search ведётся по названию папки и всех её документов-потомков любой глубины. Сортировка — по дате последнего изменения документов по убыванию. Рядом с data возвращается pagination (мета пагинации). Требуется подтверждённый email.
   * @summary Список папок документов пользователя
   * @param {number} [page] Номер страницы (по умолчанию 1)
   * @param {number} [perPage] Записей на странице, 1–100 (по умолчанию из server-options.pagination.default_per_page)
   * @param {string} [search] Поиск по подстроке названия папки и названий всех её документов-потомков (без учёта регистра)
   * @param {Array<UserDocumentType>} [types] Фильтр по типам бизнес-сущностей — владельцев папок; параметр можно передать несколько раз
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserDocumentsApiInterface
   */
  getUserDocumentListRaw(
    requestParameters: GetUserDocumentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserDocumentList200Response>>

  /**
   * Постраничный список корневых папок документов текущего пользователя. Обычный пользователь видит только папки своих заявок и запросов на товарный знак, администратор — все. Поиск search ведётся по названию папки и всех её документов-потомков любой глубины. Сортировка — по дате последнего изменения документов по убыванию. Рядом с data возвращается pagination (мета пагинации). Требуется подтверждённый email.
   * Список папок документов пользователя
   */
  getUserDocumentList(
    requestParameters: GetUserDocumentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserDocumentList200Response>
}

/**
 *
 */
export class UserDocumentsApi
  extends runtime.BaseAPI
  implements UserDocumentsApiInterface
{
  /**
   * Отдаёт файл документа бинарным потоком, без конверта success_response: заголовки Content-Type (MIME-тип файла), Content-Disposition и Content-Length. uuid должен указывать на документ, а не на папку. Документ чужой бизнес-сущности не отличается от несуществующего — 404 (администратору доступен любой). Требуется подтверждённый email.
   * Скачать файл документа
   */
  async getUserDocumentFileRaw(
    requestParameters: GetUserDocumentFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['uuid'] == null) {
      throw new runtime.RequiredError(
        'uuid',
        'Required parameter "uuid" was null or undefined when calling getUserDocumentFile().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-documents/{uuid}/file`.replace(
          `{${'uuid'}}`,
          encodeURIComponent(String(requestParameters['uuid']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Отдаёт файл документа бинарным потоком, без конверта success_response: заголовки Content-Type (MIME-тип файла), Content-Disposition и Content-Length. uuid должен указывать на документ, а не на папку. Документ чужой бизнес-сущности не отличается от несуществующего — 404 (администратору доступен любой). Требуется подтверждённый email.
   * Скачать файл документа
   */
  async getUserDocumentFile(
    requestParameters: GetUserDocumentFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getUserDocumentFileRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Содержимое папки: данные папки и документы внутри неё с временными ссылками на файлы (список не пагинируется, сортировка по дате создания по возрастанию). Папка чужой бизнес-сущности не отличается от несуществующей — 404 (администратору доступна любая папка). Требуется подтверждённый email.
   * Документы внутри папки
   */
  async getUserDocumentItemRaw(
    requestParameters: GetUserDocumentItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserDocumentItem200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getUserDocumentItem().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-documents/{applicationId}`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetUserDocumentItem200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Содержимое папки: данные папки и документы внутри неё с временными ссылками на файлы (список не пагинируется, сортировка по дате создания по возрастанию). Папка чужой бизнес-сущности не отличается от несуществующей — 404 (администратору доступна любая папка). Требуется подтверждённый email.
   * Документы внутри папки
   */
  async getUserDocumentItem(
    requestParameters: GetUserDocumentItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserDocumentItem200Response> {
    const response = await this.getUserDocumentItemRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Постраничный список корневых папок документов текущего пользователя. Обычный пользователь видит только папки своих заявок и запросов на товарный знак, администратор — все. Поиск search ведётся по названию папки и всех её документов-потомков любой глубины. Сортировка — по дате последнего изменения документов по убыванию. Рядом с data возвращается pagination (мета пагинации). Требуется подтверждённый email.
   * Список папок документов пользователя
   */
  async getUserDocumentListRaw(
    requestParameters: GetUserDocumentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserDocumentList200Response>> {
    const queryParameters: any = {}

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search']
    }

    if (requestParameters['types'] != null) {
      queryParameters['types[]'] = requestParameters['types']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-documents`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetUserDocumentList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Постраничный список корневых папок документов текущего пользователя. Обычный пользователь видит только папки своих заявок и запросов на товарный знак, администратор — все. Поиск search ведётся по названию папки и всех её документов-потомков любой глубины. Сортировка — по дате последнего изменения документов по убыванию. Рядом с data возвращается pagination (мета пагинации). Требуется подтверждённый email.
   * Список папок документов пользователя
   */
  async getUserDocumentList(
    requestParameters: GetUserDocumentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserDocumentList200Response> {
    const response = await this.getUserDocumentListRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetUserDocumentFileTypeEnum {
  Inline = 'inline',
  Attachment = 'attachment',
}
